require("dotenv").config();

export enum ENV {
  prod = "production",
  dev = "development",
  test = "test",
}

export const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;
export const TRONSCAN_ADDRESS = process.env.REACT_APP_TRONSCAN_ADDRESS;
export const TRONSCAN_API_ADDRESS = process.env.REACT_APP_TRONSCAN_API_ADDRESS;
export const RISE_CONTRACT_ADDRESS =
  process.env.REACT_APP_RISE_CONTRACT_ADDRESS || "";
export const CASH_CONTRACT_ADDRESS =
  process.env.REACT_APP_CASH_CONTRACT_ADDRESS || "";
export const MINTSAVER_ADDRESS = process.env.REACT_APP_MINTSAVER_ADDRESS;
export const TRON_PRIVATE_KEY = process.env.REACT_APP_TRON_PRIVATE_KEY;
export const TRON_HOST = process.env.REACT_APP_TRON_HOST || "";
export const TRON_FULL_HOST = process.env.REACT_APP_TRON_FULL_HOST || "";
export const TRON_FULL_NODES = process.env.REACT_APP_TRON_FULL_NODES || "";
export const TRON_SOLIDITY_NODES =
  process.env.REACT_APP_TRON_SOLIDITY_NODES || "";

export const API_COINGEKO = "https://api.coingecko.com/api";
